<script setup lang="ts">

import IOHeaderContainer from '~/components/io/io-header/IOHeaderContainer.vue'
import IOMobileHeader from '~/components/io/io-header/IOMobileHeader.vue'

const { $io } = useNuxtApp()

import { ioHeader, mobileMenuSnapPoint } from '@/io'
// Manage fixed state of the header
// inside <script setup> of default.vue
const MobileMenuActive = ref(false)
const isUnmounting = ref(false)

// Create a stop handle for the watchEffect
let stopWatcher: (() => void) | null = null

onMounted(() => {
  const { ww } = useViewport()
  stopWatcher = watchEffect(() => {
    if (!isUnmounting.value) {
      MobileMenuActive.value = ww.value < mobileMenuSnapPoint
    }
  })
})

// Clean up watchers before unmounting to prevent race conditions
onBeforeUnmount(() => {
  isUnmounting.value = true
  if (stopWatcher) {
    stopWatcher()
    stopWatcher = null
  }
})


const props = withDefaults(defineProps<{
  primaryC?: string
  primaryW?: string
}>(), {
  primaryC: '',
  primaryW: 'flex g-1 mw-92 w-full mx-auto justify-between',
})

const route = useRoute()
const routeName = computed(() => String(route.name))
const routeSlug = computed(() => String(route.params.slug))

const isMounted = useMounted()

const headerFixed = computed(() => $io.headerFixed)
const headerFixedMini = computed(() => $io.headerFixedMini)

const hydrated = ref(false)
onMounted(() => { hydrated.value = true })


</script>

<template>
<div 
class="io-header" 
:class="[
  routeName,
  routeSlug,
  // add scroll-dependent classes **only after** hydration
  hydrated && { 'header-fixed': headerFixed },
  hydrated && { 'header-fixed-mini': headerFixedMini }
]" >

  <slot name="before" />

  <IOHeaderContainer 
    class="layer layer-header-container z-15" 
    :class="primaryC"
    :w="primaryW"
    v-if="isMounted && !MobileMenuActive && !isUnmounting"
  >
    <slot name="header-before" />
    
    <slot name="primary">
      <Frame class="module sec-branding">
        -- Branding -- 
      </Frame>
      <Frame class="module sec-navigation">
        -- Navigation --
      </Frame>
      <Frame class="module sec-actions">
      -- Actions --
      </Frame>
    </slot>

    <slot name="header-after" />
  </IOHeaderContainer>

  <slot v-if="MobileMenuActive && !isUnmounting" name="mobile">
    <IOMobileHeader>
      <template #flyoutheader>
        This is the flyout header 
      </template>
    </IOMobileHeader>
  </slot>

  <slot name="after" />

</div>
</template>

<style lang="scss" scoped>


.io-header {
  transition: all 0.75s ease-in-out;

  :deep(.sec-header-bg-gradiant) {
    
  }
  /* Desktop */
  .primary-header-container {
    height: 100px;

    :deep(.sec-branding) {
      
    }

    :deep(.sec-primary-menu) {
      height: 100px;
      transition: all 0.3s ease-in-out;
      transform: translateY(4px);
    }


    :deep(.logo-container) {
      background: white;
      width: 200px;
      height: 100px;
      border-radius: 0 0 0.25rem 0.25rem;
     

      @include mq($from: d) {
        width: 220px;
        height: 125px;
      }
      >img {
        padding: gr(0.7);

        @include mq($from: d) {
          padding: gr(0.8);
        }
      }
    }

  
  }

  /* Mobile */
  :deep(>.sec-mobile-navigation) {
   
  }


  &.header-fixed {

    :deep(.sec-header-bg-gradiant) {
      display: none;
    }

    /* Mobile */
    :deep(>.sec-mobile-navigation) {
      background: white;
      button {
        &.logo {
          height: 90px;
          top:0;

          @include mq($from: ds, $until: d) {
            height: 100px;
            top: 5px;
          }
        }
      }

      .btn-flyout-trigger {
        .hamburger {
          .line {
            background: var(--c-sky-blue);
          }
        }
      }
    }

    /* Desktop */
    /* height: 80px; */
    .primary-header-container {
      height: 80px;
      background: white;


      :deep(.logo-container) {
        background: white;
        width: 160px;
        height: 80px;
        border-radius: 0 0 0.25rem 0.25rem;
        >img {
          padding: 3px;
        }
      }

    }



  }
}


</style>
